import styled from 'styled-components';

import { Stack } from '@components/stack';

import { baseTabStyles, TabActiveProps, TabContent, TabDisplay } from './common';

export type StateTabItem = TabDisplay & {
  id: string;
};

export type StateTabsProps = {
  tabs: StateTabItem[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  /** Accessible name for the tab group. When set, the strip is exposed as an ARIA tablist. */
  ariaLabel?: string;
};

export const StateTabs = ({ tabs, activeTab, onTabChange, ariaLabel }: StateTabsProps) => {
  const isTablist = ariaLabel !== undefined;

  return (
    <Stack orientation="horizontal" role={isTablist ? 'tablist' : undefined} aria-label={ariaLabel}>
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab;

        return (
          <TabButton
            key={tab.id}
            type="button"
            onClick={() => onTabChange(tab.id)}
            $active={isActive}
            role={isTablist ? 'tab' : undefined}
            aria-selected={isTablist ? isActive : undefined}
            aria-current={isActive ? 'page' : undefined}
            data-testid={tab.dataTestId}
          >
            <TabContent tab={tab} isActive={isActive} />
          </TabButton>
        );
      })}
    </Stack>
  );
};

const TabButton = styled.button<TabActiveProps>(baseTabStyles);
